import Icon from "carbon-react/esm/components/icon";

import { StatusPill } from "../components/StatusPill";

interface SettingsOverviewPageProps {
  onNavigate(path: string): void;
}

const settingsItems = [
  {
    description: "Review the active Sage company context, connection health, and master-data availability.",
    icon: "connect" as const,
    path: "/settings/sage",
    status: "Available",
    title: "Sage connection",
  },
  {
    description: "Configure the organization journal and posting behavior.",
    icon: "bank" as const,
    path: "/settings/accounting",
    status: "Available",
    title: "Accounting settings",
  },
  {
    description: "Manage operational application and email notifications.",
    icon: "alert_on" as const,
    path: "/settings/notifications",
    status: "Coming later",
    title: "Notifications",
  },
  {
    description: "Configure document constraints, retention, and processing availability.",
    icon: "document_right_align" as const,
    path: "/settings/documents",
    status: "Coming later",
    title: "Documents",
  },
];

export function SettingsOverviewPage({ onNavigate }: SettingsOverviewPageProps) {
  return (
    <section aria-labelledby="settings-overview-heading" className="settings-overview">
      <div className="settings-overview__heading">
        <h2 id="settings-overview-heading">Organization settings</h2>
        <p>Select an area to review or configure its organization-wide defaults.</p>
      </div>

      <nav aria-label="Organization settings" className="settings-menu">
        {settingsItems.map((item) => {
          const available = item.status === "Available";
          return (
            <button
              className="settings-menu__item"
              key={item.path}
              onClick={() => onNavigate(item.path)}
              type="button"
            >
              <span aria-hidden="true" className="settings-menu__icon">
                <Icon type={item.icon} />
              </span>
              <span className="settings-menu__copy">
                <span className="settings-menu__title">{item.title}</span>
                <span className="settings-menu__description">{item.description}</span>
              </span>
              <StatusPill label={item.status} tone={available ? "positive" : "neutral"} />
              <Icon aria-hidden type="chevron_right" />
            </button>
          );
        })}
      </nav>
    </section>
  );
}
